import { render, staticRenderFns } from "./DebrisField.vue?vue&type=template&id=f0ae60a4&scoped=true&"
import script from "./DebrisField.vue?vue&type=script&lang=js&"
export * from "./DebrisField.vue?vue&type=script&lang=js&"
import style0 from "./DebrisField.vue?vue&type=style&index=0&id=f0ae60a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ae60a4",
  null
  
)

export default component.exports